import { useRentalManagerAccountViewZrmPropertiesWebApiHandler_options } from '@zg-rentals/ts-rental-manager-api-client-react-query';

import type { RentalManagerAccountViewZrmPropertiesWebApiHandler_options_Options } from '@zg-rentals/ts-rental-manager-api-client-react-query';

export const usePropertyTablePropertyOptions = (
  groupId: string,
  options: Partial<RentalManagerAccountViewZrmPropertiesWebApiHandler_options_Options> = {},
) => {
  const { data, error, isFetching } = useRentalManagerAccountViewZrmPropertiesWebApiHandler_options(
    { groupId },
    {
      ...options,
      enabled: Boolean(groupId) && (options.enabled ?? true),
      meta: {
        tags: ['propertyTablePropertyOptions', groupId],
        context: {
          api: 'useRentalManagerAccountViewZrmPropertiesWebApiHandler_options',
          details: 'usePropertyTablePropertyOptions',
        },
      },
    },
  );

  return {
    data,
    isFetching,
    error,
  };
};
